<mat-expansion-panel (opened)="onPanelOpen()" (closed)="onPanelClose()" class="panel-container" #outerPanel>
  <mat-expansion-panel-header class="panel-container-inner">
    <mat-panel-title class="panel-main-title" i18n>
      Organizations
    </mat-panel-title>
    <mat-panel-description>
      {{orgOpenState() ? '' : OrgOpenStateDescription}}
    </mat-panel-description>
  </mat-expansion-panel-header>
  <div class="inner-accordion-container" [class.expanded]="outerPanel.expanded" [class.collapsed]="!outerPanel.expanded">
    <mat-expansion-panel class="org-expansion-panel">
      <mat-expansion-panel-header class="panel-container-inner">
        <mat-panel-title i18n fxLayout="row" fxLayoutAlign="start center">
          <mat-icon class="left-icon-with-margin">people</mat-icon>
          <span fxFlex>+ Add Organization</span>
        </mat-panel-title>
        <mat-panel-description i18n>
          Code provided by administrator.
        </mat-panel-description>
      </mat-expansion-panel-header>
      <button class="button-container" i18n>
        <mat-icon class="left-icon">vpn_key</mat-icon>
        <span class="button-text" (click)="orgKeyManual()">Enter Verification Key</span>
        <mat-icon class="button-icon">launch</mat-icon>
      </button>
      <button class="button-container" i18n (click)="scanQR()">
        <mat-icon class="left-icon">qr_code</mat-icon>
        <span class="button-text">Scan QR Code</span>
        <mat-icon class="button-icon">launch</mat-icon>
      </button>
    </mat-expansion-panel>
    <mat-accordion [multi]="true" style="margin-top: 10px;">
      @if(organizations.length > 0) {
        <app-organizations-item i18n-title title="Organizations"
          [openDescription]="openDescription"
          [closedDescription]="closeDescription" [organizations]="organizations"
        ></app-organizations-item>
      }
    </mat-accordion>
  </div>

</mat-expansion-panel>